import { render, staticRenderFns } from "./StudentRelationsCourseList.vue?vue&type=template&id=39e95d1b&"
import script from "./StudentRelationsCourseList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports